"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('controller.framework', function (frameId) {
    namespace_1.default.utils.extend(this, new namespace_1.default.controller(frameId));
    this.idPrefix = 'controller:framework';
    this.frameId = frameId; // has to be passed from init
    this.init = function (container) {
        namespace_1.default.debug.showInfo('#' + this.frameId + ': Initializing ' + this.id);
        this.bindEvents();
        if (!container)
            container = '';
        this.container = '#' + this.frameId + ' ' + container;
        this.getData();
        var tEvent = jquery_1.default.Event(this.frameId + namespace_1.default.events.framework.done);
        (0, jquery_1.default)(document).triggerHandler(tEvent);
    };
});
